export const IFRAME_MIN_HEIGHT = 500;
export const SKIN_CARE_MODE = 'capture';
export const FACE_CONCERN_PARAM = 'face_concern';
export const EYE_CONCERN_PARAM = 'eye_concern';
export const SKIN_TYPE_PARAM = 'skin_type';
export const SKIN_TYPE_VALUE = 'Normal / Combo';
export const DEFAULT_LOCALE = 'en_US';
export const DRUPAL_API_TOKEN = '0709040f8da71ca45eceb1ab8f2d8c5a';
export const DRUPAL_API_FIELDS = '+rendered,+attached';
export const SKU_ITEM = 'sku';
export const PRODUCT_ITEM = 'product';
export const REVISION_TAG_COOKIE = 'ELC_SITE_TAG';
export const LOCALE_COOKIE = 'LOCALE';
export const SCROLL_TIMEOUT = 100;
export const OFFSET_HEIGHT = 50;
export const SCROLL_BEHAVIOR_SMOOTH = 'smooth';
export const SCROLL_BLOCK_START = 'start';
export const EDITORIAL_NODE_KEY = 'skinCareEditorialNode';

export enum Events {
    CAMERA_CLOSED = 'cameraClosed',
    CAMERA_FAILED = 'cameraFailed',
    CAMERA_OPENED = 'cameraOpened',
    CLOSED = 'closed',
    LOADED = 'loaded',
    LOADING = 'loading',
    OPENED = 'opened',
    VIDEO_LOADED = 'videoLoaded',
    SKIN_ANALYSIS_STARTED = 'skinAnalysisStarted',
    SKIN_ANALYSIS_FINISHED = 'skinAnalysisFinished',
    SKIN_BACK_TO_DETECTING = 'skinBackToDetecting'
}

export enum FaceConcerns {
    linesAndWrinkles = 'lines_and_wrinkles',
    spot = 'spot',
    texture = 'texture',
    redness = 'redness'
}

export enum EyeConcerns {
    wrinkleEyes = 'wrinkle_eyes',
    darkCircle = 'dark_circle'
}

export enum OtherConcerns {
    wrinkleForehead = 'wrinkle_forehead',
    wrinkleLowerFace = 'wrinkle_lower_face'
}

export enum QuizApiConcerns {
    linesAndWrinkles = 'Lines and Wrinkles',
    spot = 'Dark Spots',
    texture = 'Uneven Texture',
    redness = 'Irritation/Redness',
    wrinkleEyes = 'Fewer Lines/ Wrinkles',
    darkCircle = 'Brighten Dark Circles'
}

export const blockPositionMapping: {
    [key: string]: string;
} = Object.freeze({
    productGrid: 'productGridPosition',
    crosssellNode: 'crosssellNodePosition',
    extraCareNode: 'extraCareNodePosition',
    skinDiagramNode: 'skinDiagramNodePosition',
    skincareRegimenNode: 'skinCareRegimenNodePosition',
    skinTipsNode: 'skinTipsNodePosition',
    skinCareEditorialNode: 'skinCareEditorialNodePosition'
});
